import React, { useState } from 'react'
import dayjs from 'dayjs';
import { Form, Input, Toast, Button, TextArea, DatePicker, } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import NavbarH5 from '../../cpnH5/NavbarH5';
import { useFeiyongAddMutation } from '../../store/NeiZhangFeiYongApi';
import ExpenseTypeSelectH5 from '../type/ExpenseTypeSelectH5';
import ImageUploaderH5 from '../../cpnH5/ImageUploaderH5';

function ExpenseAddH5(props) {
    const e_id = JSON.parse(localStorage.getItem('e_id'));
    const eu_id = JSON.parse(localStorage.getItem('eu_id'));
    const eu_name = JSON.parse(localStorage.getItem('eu_name'));
    const [form] = Form.useForm();  
    const [info, setInfo] = useState({
        fy_amount: '',
        fy_content: '',
        fy_date: dayjs().format('YYYY-MM-DD'),
        fy_month: dayjs().format('YYYY-MM'),
        fy_year: dayjs().format('YYYY'),
        fy_image: '',
    });
    
    const [addBalance] = useFeiyongAddMutation();
    const navi = useNavigate();

    const handleSubmit = async () => {
        try {
            // Validate form fields
            await form.validateFields();
            
            // Submit data
            const result = await addBalance({
                "fy_amount" : info.fy_amount,
                "fy_content" : info.fy_content,
                "fy_date" : info.fy_date,
                "fy_month" : info.fy_month,
                "fy_year" : info.fy_year,
                "fy_fyt_id" : info.fy_fyt_id,
                "fy_fyt_name" : info.fy_fyt_name,
                "fy_image" : info.fy_image,
                "fy_qy_id" : e_id,
                "fy_uid" : eu_id,
                "fy_uname" : eu_name,
            });

            if (result.data.Status === 'success') {
                Toast.show({
                    icon: 'success',
                    content: '保存成功',
                });
                form.resetFields();
                navi('/ExpenseListH5')
            } else {
                Toast.show({
                    icon: 'fail',
                    content: result.data.Message || '保存失败',
                });
            }
        } catch (error) {
            Toast.show({
                icon: 'fail',
                content: '请填写完整信息',
            });
            console.error('Submit error:', error);
        }
    };
    return (
        <div>
            <NavbarH5 title='新增费用' onBack={() => {navi('/DeskHomeH5')}}/>
            <Form
                form={form}
                layout='horizontal'
                name="form_client"
                initialValues={{
                    fy_date: new Date(), // 设置默认值为当前日期
                    
                }}
                onFinish={handleSubmit}
                footer={
                    <Button 
                        color='primary' 
                        fill='solid' 
                        type='submit' 
                        block
                    >
                        保存
                    </Button>
                }
            >
                <ExpenseTypeSelectH5
                    name='fy_fyt_id'
                    required
                    label='费用类型'
                    e_id={e_id}
                    onChange={(e,f) => {                                                
                                            console.log(e,f);
                                            
                                            setInfo(prevState=>({...prevState,fy_fyt_id:e,fy_fyt_name:f}))
                                        }}
                />
                 <Form.Item
                    required
                    name="fy_date"
                    label='日期'
                    trigger='onConfirm'
                    onClick={(e, datePickerRef) => {
                        datePickerRef.current?.open();
                    }}
                    rules={[{ required: true, message: '请选择日期' }]}
                >
                    <DatePicker
                        onConfirm={(val) => {
                            setInfo(prev => ({
                                ...prev,
                                fy_date: dayjs(val).format('YYYY-MM-DD'),
                                fy_month: dayjs(val).format('YYYY-MM'),
                                fy_year: dayjs(val).format('YYYY'),
                            }));
                        }}
                    >
                        {value => value ? dayjs(value).format('YYYY-MM-DD') : '请选择日期'}
                    </DatePicker>
                </Form.Item>

                <Form.Item
                    name="fy_amount"
                    label='金额'
                    rules={[
                        { required: true, message: '请输入金额' },
                        { 
                            validator: (_, value) => {
                                if (value >= 0.01) return Promise.resolve();
                                return Promise.reject('金额必须 ≥ 0.01');
                            }
                        }
                    ]}
                >
                    <Input
                        type='number'
                        prefix={<>￥</>}
                        onChange={(value) => {
                            const numValue = parseFloat(value);
                            if (!isNaN(numValue)) {
                                setInfo(prev => ({ ...prev, fy_amount: numValue }));
                            }
                        }}
                        min={0.01}
                        max={99999999.99}
                        step={0.01}  // 允许输入小数
                        placeholder='请输入金额'
                    />
                </Form.Item>

                <Form.Item
                    name='fy_content'
                    label='备注'
                >
                    <TextArea
                        onChange={(value) => {
                            setInfo(prevState => ({ 
                                ...prevState, 
                                fy_content: value 
                            }));
                        }}
                        rows={2}
                        placeholder='请输入备注'
                    />
                </Form.Item>
                <ImageUploaderH5 
                    maxCount='10'
                    label='图片'
                    name='fy_image'
                    onChange={(value) => {
                        setInfo(prevState => ({ 
                            ...prevState, 
                            fy_image: value 
                        }));
                    }}
                />                
            </Form>
        </div>
    )
}

export default ExpenseAddH5;